var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [_vm._m(0), _vm._v(" "), _c("app-backend-footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid xyz" }, [
      _c("div", { staticClass: "page-header-top-container" }, [
        _c("div", { staticClass: "page-name" }, [_vm._v("Contact Grid")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "admin-page-content" }, [
        _c("div", { staticClass: "contact-grid-container" }, [
          _c("div", { staticClass: "row no-margin" }, [
            _c("div", { staticClass: "col-6 paddingleft0" }, [
              _c("div", { staticClass: "contactgrid" }, [
                _c("div", { staticClass: "media" }, [
                  _c("img", {
                    staticClass: "mr-3",
                    attrs: {
                      src: "/static/images/elizabeth-lizarraga.jpg",
                      alt: "Elizabeth Lizarraga"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _c("h5", { staticClass: "mt-0" }, [
                      _vm._v("Elizabeth Lizarraga")
                    ]),
                    _vm._v(" "),
                    _c("h6", [_vm._v("Director of Human Resources, VVG")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "795 Folsom Ave, Suite 600 San Francisco, CADGE 94107"
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Contact: "),
                      _c("strong", [_vm._v("(123) 456-7890")])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 paddingright0" }, [
              _c("div", { staticClass: "contactgrid" }, [
                _c("div", { staticClass: "media" }, [
                  _c("img", {
                    staticClass: "mr-3",
                    attrs: {
                      src: "/static/images/elizabeth-lizarraga.jpg",
                      alt: "Elizabeth Lizarraga"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _c("h5", { staticClass: "mt-0" }, [
                      _vm._v("Elizabeth Lizarraga")
                    ]),
                    _vm._v(" "),
                    _c("h6", [_vm._v("Director of Human Resources, VVG")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "795 Folsom Ave, Suite 600 San Francisco, CADGE 94107"
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Contact: "),
                      _c("strong", [_vm._v("(123) 456-7890")])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "height30" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 paddingleft0" }, [
              _c("div", { staticClass: "contactgrid" }, [
                _c("div", { staticClass: "media" }, [
                  _c("img", {
                    staticClass: "mr-3",
                    attrs: {
                      src: "/static/images/elizabeth-lizarraga.jpg",
                      alt: "Elizabeth Lizarraga"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _c("h5", { staticClass: "mt-0" }, [
                      _vm._v("Elizabeth Lizarraga")
                    ]),
                    _vm._v(" "),
                    _c("h6", [_vm._v("Director of Human Resources, VVG")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "795 Folsom Ave, Suite 600 San Francisco, CADGE 94107"
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Contact: "),
                      _c("strong", [_vm._v("(123) 456-7890")])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 paddingright0" }, [
              _c("div", { staticClass: "contactgrid" }, [
                _c("div", { staticClass: "media" }, [
                  _c("img", {
                    staticClass: "mr-3",
                    attrs: {
                      src: "/static/images/elizabeth-lizarraga.jpg",
                      alt: "Elizabeth Lizarraga"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _c("h5", { staticClass: "mt-0" }, [
                      _vm._v("Elizabeth Lizarraga")
                    ]),
                    _vm._v(" "),
                    _c("h6", [_vm._v("Director of Human Resources, VVG")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "795 Folsom Ave, Suite 600 San Francisco, CADGE 94107"
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Contact: "),
                      _c("strong", [_vm._v("(123) 456-7890")])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f27cb63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f27cb63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact-grid.vue
// module id = null
// module chunks = 